import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiAlertsService } from '@core/api/services/alerts/api-alerts.service';
import { filter, map, of, switchMap, tap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorFromHttpErrorResponse } from '@core/services/request/util/error-from-http';
import { alertsActions } from '@store/actions/alerts.actions';
import { AlertsMapper } from '@core/domain/mappers/alerts/alerts.mapper';
import { AcDialogService } from '@core/services/dialog/ac-dialog.service';
import { FloatingAlertsService } from '@shared/components/floating-alerts/data/floating-alerts.service';

@Injectable()
export class AlertsEffects {
  fetchAlertsList$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(alertsActions.fetchAlerts),
      switchMap(() =>
        this._api.fetchActiveAlerts().pipe(
          map(AlertsMapper.requestFromApiToDomain),
          map((value) => value.data),
          map((data) => alertsActions.setAlerts({ data })),
          catchError((error) => of(alertsActions.errorAlerts({ error: errorFromHttpErrorResponse(error) })))
        )
      )
    );
  });
  deleteAlert$ = createEffect(() =>
    this._actions$.pipe(
      ofType(alertsActions.deleteAlert),
      switchMap(({ alert }) =>
        this._acDialog.confirmationDialog('ALERTS.CONFIRM_ALERT_DELETION').pipe(
          filter((value) => !!value),
          map(() => alert)
        )
      ),
      switchMap((alert) =>
        this._api.removeAlert(alert.idAlertUser).pipe(
          map((value) => value.data),
          tap((success) => {
            if (success) {
              this._floatingAlerts.info('ALERTS.ALERT_DELETED_SUCCESSFULLY');
            }
          }),
          map(() => alertsActions.fetchAlerts()),
          catchError(() => of(alertsActions.fetchAlerts()))
        )
      )
    )
  );
  constructor(
    private _actions$: Actions,
    private _api: ApiAlertsService,
    private readonly _acDialog: AcDialogService,
    private readonly _floatingAlerts: FloatingAlertsService
  ) {}
}
